import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { BaseRichService } from '../../../providers/base-rich.service';
import { BaseListComponent } from '../../shared/base-list/base-list.component';
import { CommentFormComponent } from '../comment-form/comment-form.component';

@Component({
  selector: 'app-comment-list',
  templateUrl: '../../shared/base-list/base-list.component.html',
  styleUrls: ['./comment-list.component.scss', '../../shared/base-list/base-list.component.scss']
})
export class CommentListComponent extends BaseListComponent implements OnInit, OnChanges {

  // selectedRows: any;
  // selectAct: any;
  // hideChangeMode = true;
  @Input() ref: any;
  @Input() base: any;

  constructor(
    public cookieService: CookieService,
    public service: BaseRichService,
    public translator: TranslateService,
    public activeModal: NgbModal,
    public titleService: Title,
  ) {
    super(cookieService, activeModal, titleService, translator, service);
    this.title = 'comments';
    this.entity = 'comment';
    this.form = CommentFormComponent;
  }

  getBody(): any {
    const body = super.getBody();
    body.query = [
      ['entity', '=', this.base],
      'and',
      ['ref', '=', this.ref]
    ];
    return body;
  }

  create(params?) {
    super.create({ entity: this.base, ref: this.ref });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.ref && this.meta) {
      this.load();
    }
  }
}
